import type { AxiosInstance } from 'axios';
import { createCrudService, type CrudService } from '../core/crud';
import type { WebhookDelivery, WebhookDeliveryCreate, WebhookDeliveryFilter } from '../data/webhookDelivery';

export function createWebhookDeliveryService(client: AxiosInstance) {
  return createCrudService<WebhookDelivery, WebhookDeliveryCreate, WebhookDeliveryFilter>(
    client,
    '/notifications/WebhookDelivery',
    'id',
  );
}

export type WebhookDeliveryService = CrudService<WebhookDelivery, WebhookDeliveryCreate, WebhookDeliveryFilter>;
